module.exports = __webpack_public_path__ + "img/pengyouquan.ed483813.png";